import React from 'react'

import { modalActions, modalSelectors } from 'src/store/modal'

import { Modal } from 'antd'

const GlobalModalRenderer: React.FC = () => {
    const modals = modalSelectors.useModals()

    const runAction = async (action?: () => unknown) => {
        if (!action) {
            return true
        }

        try {
            const result = await action()
            return result !== false
        } catch {
            return false
        }
    }

    const handleOk = async (modalId: number, action?: () => unknown) => {
        const shouldClose = await runAction(action)
        if (shouldClose) {
            modalActions.closeModal(modalId)
        }
    }

    const handleCancel = async (modalId: number, action?: () => unknown) => {
        const shouldClose = await runAction(action)
        if (shouldClose) {
            modalActions.closeModal(modalId)
        }
    }

    return (
        <>
            {modals.map((modal, index) => (
                <Modal
                    key={modal.id}
                    open={modal.open}
                    title={modal.title}
                    okText={modal.okText}
                    cancelText={modal.cancelText}
                    okButtonProps={modal.okButtonProps}
                    cancelButtonProps={modal.cancelButtonProps}
                    centered={modal.centered}
                    closable={modal.closable}
                    className={modal.className}
                    width={modal.width}
                    destroyOnClose={modal.destroyOnClose}
                    maskClosable={modal.maskClosable}
                    footer={modal.footer}
                    zIndex={1001 + index}
                    onOk={() => handleOk(modal.id, modal.onOk)}
                    onCancel={() => handleCancel(modal.id, modal.onCancel)}
                    afterClose={() => modalActions.removeModal(modal.id)}
                >
                    {modal.content}
                </Modal>
            ))}
        </>
    )
}

export default GlobalModalRenderer
